import { connect } from 'react-redux';
import { Container } from './Modal';
import * as selectModal from '@app/src/commons/modal/state/modals/selectors';
import { closeModal } from '@app/src/commons/modal/state/modals/actions';

const mapStateToProps = state => ({
  openModal: selectModal.getState(state)
});

const mapDispatchToProps = dispatch => ({
  closeModal: () => dispatch(closeModal())
});

export const ModalContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Container);
